import React, { Component } from "react";
import { connect } from "react-redux";
import CMSHeader from "./CMSHeader";
import CMSHeader2 from "./CMSHeader2";
import CMSFooter from "./CMSFooter";
import * as Api from "../../../../data/ApiRequest";
import * as path from "../../../../data/ApiList";
import {CountryCodeOption} from "../Comman/CountryCodeOption"
import {stateList} from '../Comman/Statelist'
import {toast } from 'react-toastify'; 
import Loading from "../../../common/Loading";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
class CMSPage extends Component {


   intState={
    access_token:"",
    property_address:"",
    city:"",
    first_name:"",
    last_name:"",
    Email_id:"",
    country_code:"+61",
    phone:"",
    funding_amount:"",
    state:"",
    termconditonCheck:false,
    enableTermStatus:"",
  
    }
    constructor() {
        super();
        this.state = {
            toggleSidebar:false,
            firstName:"",
            lastName:"",
            reciveConsumerData:{},
             directConsumState:this.intState,
             reciveStatus:false,            
             checkTermCondition:true,
             show:false,
             reciveStatusCode:200,
             message:[]
           
        }
    }
   
    componentDidMount=async()=>{
      document.title ="";
   const pathRecive= this.props.location?.pathname;
   const params = new URLSearchParams(this.props.location.search);
   var splitUrl = pathRecive.split('/');
   this.setState({
    ...this.state,
    directConsumState: {
      ...this.state.directConsumState,
      access_token: splitUrl[1],    
    }
  })
  try{
    
    let connectorId = (params.get("connectorid") !=undefined) ? params.get("connectorid") : "";
    let code = (params.get("code") !=undefined) ? params.get("code") : "";
    let url = path.DIRECT_POLLING_REX_URL+"/"+connectorId+"/"+code
    await Api.getRequest(url).then((res1)=>{     
      this.setState({
        reciveConsumerData:res1.data,
        reciveStatusCode:res1.status,
        message:res1.data.data, 
        reciveStatus:true,     
      })
     
      });
  }catch(error){
    this.setState({
      reciveStatusCode:error.response.status,
      message:error.message,
      reciveStatus:false,
    })
  }

  
  }

 showLoader =()=>{
  this.setState({
    reciveStatus:true
  })

 }

    render() {
      
        return (
          
            <React.Fragment>
             
              { this.state.reciveStatusCode === 200 ? (<>{this.state.reciveStatus=== false &&<Loading/>}    
         
         
         <CMSHeader/>
         <div className='et_pb_section'></div> 
    
        <div className="et_pb_row">
            <div className="container"><ul className="list-unstyled" >
                {this.state.message.map((datas, index) => (
                    <li className={(datas.error ==true) ? "errorMsg" : "successMsg" } key={index}>{`${index+1}. `}{datas.message}</li>
                ))}
            </ul>
            </div>
            </div>            
<CMSFooter data={this.state.reciveConsumerData.slug} /></>):(<> <div className="center-data">
            <div className="no-match container">
              <div className="error-msg">
                <h1>ERROR {this.state.reciveStatusCode}</h1>
                <h2>ACCESS FORBIDDEN</h2>
                <p>The page your are trying to access is not Authorized to you. Please contact Adminstrator.</p>
        </div>
            </div>
        </div></>)}
            
            </React.Fragment>
        );
    }
}



const mapStateToProps = (state) => {
   {}
};

CMSPage.propTypes = {
   
};

export default connect(mapStateToProps, {
   
})(CMSPage);

//export default CMSHeader;